<div class="read-more d-flex w-100 justify-content-end pointer-cursor">
  <a>
    <span class="mr-3" translate>Read More</span>

    <i class="fas fa-arrow-alt-circle-right"></i>
  </a>
</div>
